if (window.tbyb) {
  let __isCustomScriptEventListenerRegistered__ = false;

  document.addEventListener('tbyb_cart_update', async function () {
    if (!__isCustomScriptEventListenerRegistered__) {
      __isCustomScriptEventListenerRegistered__ = true;
      applyTBYBQuantityBtnDisableEventListener();
    }

    await waitForElm('#tbybButton').then((element) => {
      const jqueryElement = $('#quantity');
    
  
      if (jqueryElement.val() != tbyb.config.rules.maxCountPerItem) {
        document.querySelector('#tbybButton').disabled = 'true';
      }
    });
  });
}

function applyTBYBQuantityBtnDisableEventListener() {
  const jqueryElement = $('#quantity');

  if (jqueryElement) {
    jqueryElement.on('change', function (event) {
      if (Number.parseInt(event.target.value) > Number.parseInt(tbyb.config.rules.maxCountPerItem)) {
        setTBYBDisabledAttribute(true);
      }

      const canAddTbybItemToCart = tbyb.validator.canAddTbybItemToCart(
        document.querySelector('[data-tbyb-product-id]').getAttribute('data-tbyb-product-id'),
        document.querySelector('[data-tbyb-variant-id]').getAttribute('data-tbyb-variant-id')
        );
      if (event.target.value == tbyb.config.rules.maxCountPerItem && canAddTbybItemToCart) {
        setTBYBDisabledAttribute(false);
      }
    });
  }
}

function setTBYBDisabledAttribute(bool) {
  const btn = document.querySelector('#tbybButton');
  if (btn) document.querySelector('#tbybButton').disabled = bool;
}

function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}